import { TS_AddonFlexPep } from '../TravelSeller/Models/TS_AddonFlexPep';
import { ItemType } from './ItemType';

export class AddonFlexPep extends TS_AddonFlexPep {
    type = ItemType.FLEX_PEP;
}